<div class="row mb-3">
    <label class="col col-form-label text-start" translate="CONFIRMATION_TIME_RECORDING_P40_DATE_LABEL"></label>
    <label class="col col-form-label text-start" translate="CONFIRMATION_TIME_RECORDING_P40_DURATION_LABEL"></label>
    <label class="col col-form-label text-start" translate="CONFIRMATION_TIME_RECORDING_P40_CATEGORY_LABEL"></label>
    <label
        class="col col-form-label text-start"
        translate="CONFIRMATION_TIME_RECORDING_P40_DELIVERY_TYPE_LABEL"
    ></label>
    <label
        class="col col-form-label text-start"
        translate="CONFIRMATION_TIME_RECORDING_P40_BOOKING_CATEGORY_LABEL"
    ></label>
    <label class="col col-form-label text-start" translate="CONFIRMATION_TIME_RECORDING_P40_COMMENT_LABEL"></label>
    <label class="col col-form-label text-start"></label>
</div>
<div class="text-center" *ngIf="model.timeRecordingEntries.value.length === 0">
    <span translate="CONFIRMATION_TIME_RECORDING_P40_NONE_AVAILABLE_LABEL"></span>
</div>
<div [formGroup]="timeRecordingForm">
    <fieldset>
        <div class="row mb-3" *ngFor="let entry of model.timeRecordingEntries.value; index as i">
            <div class="col">{{ entry.startDate.value.isValid() ? entry.startDate.formattedDisplayedDate : '' }}</div>
            <div class="col">
                {{ entry.duration.value.isValid() ? entry.duration.value.asMinutes() : '' }}
                <span translate="CONFIRMATION_TIME_RECORDING_P40_MINUTES_LABEL"></span>
            </div>
            <div class="col">{{ entry.category.selectedEntry?.displayName }}</div>
            <div class="col">{{ entry.delivery.selectedEntry?.displayName }}</div>
            <div class="col">{{ entry.bookingCategory.selectedEntry?.displayName }}</div>
            <div class="col">{{ entry.comments.value }}</div>
            <div class="col">
                <button
                    type="button"
                    id="btnEdit"
                    class="btn btn-secondary me-1"
                    (click)="editTimeRecording(i)"
                    [attr.aria-label]="'CONFIRMATION_TIME_RECORDING_P40_EDIT_ENTRY_TITLE' | translate"
                >
                    <fa-icon [icon]="faPencil"></fa-icon>
                </button>
                <button
                    type="button"
                    id="btnDelete"
                    class="btn btn-warning"
                    (click)="deleteTimeRecording(i)"
                    [attr.aria-label]="'CONFIRMATION_TIME_RECORDING_P40_DELETE_ENTRY' | translate"
                >
                    &times;
                </button>
            </div>
        </div>
    </fieldset>
</div>
<hr class="separator" />
<div class="row">
    <div class="col-12 d-flex">
        <button
            class="btn btn-primary ms-auto"
            (click)="addTimeRecording()"
            translate="CONFIRMATION_TIME_RECORDING_P40_ADD_TIMERECORDING_LABEL"
        ></button>
    </div>
</div>
